import { DataTablePagination, toast } from '@ui/components';
import { UserTableDto } from '@interfaces/models';
import { DataTableSearch } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { useUsers } from '@pages/users/hooks';
import { Typography } from '@ui/components';
import { DataTable } from '@ui/components';
import { Trans } from 'react-i18next';
import { useState } from 'react';

import { RemoveUserDialog } from '../remove-user-dialog/remove-user-dialog';
import { UserEditSidebar } from '../user-edit-sidebar/user-edit-sidebar';
import { useUsersTable } from './use-users-table';

export const UsersTable = () => {
  const { t } = useTranslation();

  const [isEditUserDrawerOpen, setIsEditUserDrawerOpen] = useState(false);
  const [isRemoveUserDialogOpen, setIsRemoveUserDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<UserTableDto>();

  const { table, globalFilter, isLoading, columnsLength, totalItems, refetchTable } = useUsersTable(
    {
      onEditUser: (user: UserTableDto) => {
        setIsEditUserDrawerOpen(true);
        setSelectedUser(user);
      },
      onRemoveUser: (user: UserTableDto) => {
        setIsRemoveUserDialogOpen(true);
        setSelectedUser(user);
      },
    },
  );

  const { removeUser, isRemoveUserPending } = useUsers({
    onRemoveUserSuccess: () => {
      refetchTable();
      setIsEditUserDrawerOpen(false);
      setIsRemoveUserDialogOpen(false);
      toast.success(t('USERS.REMOVE_USER_DIALOG_SUCCESS'));
    },
    onRemoveUserError: ({ errorCode }) => {
      toast.error(t(`API_ERRORS.${errorCode}`));
    },
  });

  return (
    <div className="flex flex-col bg-table-background rounded-lg overflow-hidden">
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumMedium">
          {t('USERS.TABLE_TOTAL_USERS', { count: totalItems })}
        </Typography>

        <div className="ml-auto flex items-center gap-4">
          <DataTableSearch
            placeholder={t('USERS.TABLE_SEARCH_PLACEHOLDER')}
            onChange={table.setGlobalFilter}
            value={globalFilter}
          />

          <DataTablePagination
            pageIndex={table.getState().pagination.pageIndex}
            pageSize={table.getState().pagination.pageSize}
            prevPageDisabled={!table.getCanPreviousPage()}
            nextPageDisabled={!table.getCanNextPage()}
            prevPage={() => table.previousPage()}
            nextPage={() => table.nextPage()}
            totalRows={totalItems}
          />
        </div>
      </div>
      <DataTable
        noResultsComponent={
          <Typography variant="labelMediumBook">
            <Trans i18nKey="USERS.TABLE_NO_RESULTS" />
          </Typography>
        }
        className="h-full overflow-auto"
        columnsLength={columnsLength}
        isLoading={isLoading}
        table={table}
      />

      {isRemoveUserDialogOpen && selectedUser && (
        <RemoveUserDialog
          onRemoveUser={() => removeUser(selectedUser.id)}
          onClose={() => setIsRemoveUserDialogOpen(false)}
          isOpen={isRemoveUserDialogOpen}
          isLoading={isRemoveUserPending}
          user={selectedUser}
        />
      )}
      {isEditUserDrawerOpen && selectedUser && (
        <UserEditSidebar
          onClose={({ handleSuccess }) => {
            if (handleSuccess) refetchTable();
            setIsEditUserDrawerOpen(false);
          }}
          onRemoveClick={() => setIsRemoveUserDialogOpen(true)}
          open={isEditUserDrawerOpen}
          user={selectedUser}
        />
      )}
    </div>
  );
};
